import gql from 'graphql-tag';
export default gql`
  mutation PutSpaceSaverRoomResizerExcludedOrganizers($companyId: ID!, $organizerEmails: [String!]!) {
    putSpaceSaverRoomResizerExcludedOrganizers(companyId: $companyId, organizerEmails: $organizerEmails) {
      roomResizerExcludedOrganizers
    }
  }
`;